// extracted by mini-css-extract-plugin
export var card = "_9t-0";
export var failedIcon = "_9t-4";
export var failedIconBadge = "_9t-3";
export var icon = "_9t-1";
export var successIcon = "_9t-2";